export default __webpack_public_path__ + "static/media/Ellipsis.5dd7a19d.svg";